import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';

const napasReconEmailParser = (body) => {
    const result = body?.data !== undefined ? body.data : body;
    return Array.isArray(result) ? result[0] : result;
};

export function getNapasReconEmailConfig(params) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.NAPAS_RECON_EMAIL_CONFIG,
        params,
        parser: napasReconEmailParser,
    }).get();
}

export function updateNapasReconEmailConfig(data) {
    return new ApiService({
        baseURL: Config.API_ORDER,
        endpoint: Urls.NAPAS_RECON_EMAIL_CONFIG,
    }).post({
        ...data,
        emails: (data.emails || '').split(',').map(email => email.trim()).join(','),
    });
}
